import { docReady } from '../helpers/doc-ready';
const recommendedProductsArray = [];
const selectors = {
    recommendationsWrapper: 'product-recommendations',
    specificContainer: '[data-product-specific-recommendations] .horizontal-product-list',
    defaultContainer: '[data-shopify-recommendations] .horizontal-product-list',
    hiddenContainer: '[data-hidden-recommendations]',
};
const getSpecificRecommendedProducts = (cart) => {
    var _a;
    const automaticRecommendations = document.querySelector('[data-automatic-recommendations]');
    if (automaticRecommendations) {
        const latestCartItemHandle = (_a = cart.items[0]) === null || _a === void 0 ? void 0 : _a.handle;
        if (latestCartItemHandle) {
            fetch('/products/' + latestCartItemHandle + '?view=json')
                .then((response) => {
                return response.json();
            })
                .then((data) => {
                const product = data.product;
                const recommendedProductsMetafield = product.recommended_products;
                if (recommendedProductsMetafield) {
                    recommendedProductsArray.length = 0;
                    recommendedProductsMetafield.forEach((product) => {
                        recommendedProductsArray.push(product);
                    });
                    // Metafield recommendations
                    renderSpecificRecommendedProducts(recommendedProductsArray);
                }
                else {
                    // Shopify recommendations
                    getDefaultRecommendedProducts();
                }
            });
        }
    }
};
const getDefaultRecommendedProducts = () => {
    fetch(window.Shopify.routes.root + '?sections=th-cart-drawer-shopify-recommendations')
        .then((res) => res.json())
        .then((res) => {
        const html = Object.values(res);
        const div = document.createElement('div');
        const hiddenContainer = document.querySelector(selectors.hiddenContainer);
        div.innerHTML = html;
        hiddenContainer.append(div);
    })
        .then(() => {
        const hiddenContainer = document.querySelector(selectors.hiddenContainer);
        const observerOptions = { attributes: true, childList: true, subtree: true };
        const observerFunction = (mutationList) => {
            const newRecommendations = document.querySelectorAll('#shopify-section-th-cart-drawer-shopify-recommendations .horizontal-product');
            if (newRecommendations.length > 0) {
                if (document.querySelector(selectors.defaultContainer)) {
                    document.querySelector(selectors.defaultContainer).innerHTML = '';
                    document.querySelector(selectors.defaultContainer).scrollLeft = 0;
                }
                if (document.querySelector(selectors.defaultContainer)) {
                    newRecommendations.forEach((recommendation) => {
                        document.querySelector(selectors.defaultContainer).appendChild(recommendation);
                    });
                }
            }
            getCarouselControls('cart-drawer-recommendations');
        };
        const observer = new MutationObserver(observerFunction);
        observer.observe(hiddenContainer, observerOptions);
    });
    const recommendationsWrapper = document.querySelector(selectors.recommendationsWrapper);
    recommendationsWrapper === null || recommendationsWrapper === void 0 ? void 0 : recommendationsWrapper.setAttribute('data-product-recommendations', 'shopify');
};
const renderSpecificRecommendedProducts = (products) => {
    const specificContainer = document.querySelector(selectors.specificContainer);
    if (specificContainer) {
        specificContainer.scrollLeft = 0;
        specificContainer.innerHTML = '';
        products.forEach((product) => {
            const productGridItem = product.grid_item[0];
            specificContainer.innerHTML += productGridItem;
        });
        const recommendationsWrapper = document.querySelector(selectors.recommendationsWrapper);
        recommendationsWrapper === null || recommendationsWrapper === void 0 ? void 0 : recommendationsWrapper.setAttribute('data-product-recommendations', 'product-specific');
    }
    getCarouselControls('data-product-specific-recommendations-carousel');
};
// Carousel Controls
const scrollAnim = (element, position) => {
    element.scrollTo({
        left: position,
        behavior: 'smooth',
    });
};
const getCarouselControls = (carousel) => {
    const carouselControls = document.querySelectorAll('[aria-controls="' + carousel + '"]');
    carouselControls.forEach((control) => {
        control.addEventListener('click', () => {
            const controlTarget = control.getAttribute('aria-controls');
            const targetCarousel = document.querySelector('#' + controlTarget);
            const scrollDirection = control.getAttribute('is');
            const scrollAmount = targetCarousel === null || targetCarousel === void 0 ? void 0 : targetCarousel.querySelector('.horizontal-product').offsetWidth;
            if (scrollDirection == 'prev-button') {
                scrollAnim(targetCarousel, targetCarousel.scrollLeft - scrollAmount);
            }
            else {
                scrollAnim(targetCarousel, targetCarousel.scrollLeft + scrollAmount);
            }
        });
    });
};
docReady(() => {
    // Render specific cart recommendations
    document.addEventListener('cart:change', (event) => {
        const cart = event.detail.cart;
        setTimeout(() => {
            getSpecificRecommendedProducts(cart);
        }, 500);
    });
    // Update carousel controls
    const events = ['load', 'change', 'pageshow'];
    events.forEach((event) => {
        window.addEventListener(event, () => {
            getCarouselControls('data-product-specific-recommendations-carousel');
        });
    });
});
